import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'antd';
import {
  AiOutlineGlobal,
  AiOutlineDelete,
  AiOutlineEdit,
} from 'react-icons/ai';
import BaseBtn from '../BaseBtn';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import styles from './index.module.scss';

const updatePos = (target) => {
  const right = target.getBoundingClientRect();
  const clientWidth = document.documentElement.clientWidth;

  const elHidesRight = right > clientWidth;

  return elHidesRight ? { right: 0 } : undefined;
};

const PopoverContent = ({
  url,
  onEditBtnClick,
  onDeleteBtnClick,
  onClose,
  parentRef,
}) => {
  const rootRef = useRef();

  const [pos, setPos] = useState({ right: 0 });

  const handleIntersect = useCallback(async (entries, observerElement) => {
    const entry = entries[0];

    const { isIntersecting, target } = entry;

    if (!isIntersecting) {
      const newPos = updatePos(target);
      setPos(newPos);
    } else {
      observerElement.unobserve(rootRef.current);
    }
  }, []);

  useIntersectionObserver({
    target: rootRef,
    onIntersect: handleIntersect,
    threshold: 1,
  });

  useEffect(() => {
    const outsideClickHandler = (event) => {
      if (!parentRef.current?.contains(event.target)) {
        onClose();
      }
    };

    const escKeyDownHandler = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', outsideClickHandler);
    document.addEventListener('keydown', escKeyDownHandler);

    return () => {
      document.removeEventListener('mousedown', outsideClickHandler);
      document.removeEventListener('keydown', escKeyDownHandler);
    };
  }, [parentRef, onClose]);

  const isPhoneURL = url.startsWith('tel:');

  return (
    <div
      className={styles.popoverContent}
      contentEditable={false}
      readOnly
      style={pos}
      ref={rootRef}
    >
      <AiOutlineGlobal className={styles.popoverGlobalIcon} />
      <Button
        href={url}
        target="_blank"
        type="link"
        rel="noreferrer"
        className={styles.popoverLink}
      >
        {url}
      </Button>
      <Tooltip
        title={isPhoneURL ? 'Изменить номер телефона' : 'Изменить ссылку'}
      >
        <BaseBtn
          shape="circle"
          className={styles.popoverBtn}
          onClick={onEditBtnClick}
        >
          <AiOutlineEdit />
        </BaseBtn>
      </Tooltip>
      <Tooltip title={isPhoneURL ? 'Удалить номер телефона' : 'Удалить ссылку'}>
        <BaseBtn
          shape="circle"
          className={styles.popoverBtn}
          onClick={onDeleteBtnClick}
        >
          <AiOutlineDelete />
        </BaseBtn>
      </Tooltip>
    </div>
  );
};

export default PopoverContent;
